import React from "react";
import {
  ResponsiveContainer, XAxis, YAxis, Tooltip as RTooltip, AreaChart, Area, CartesianGrid, Legend,
} from "recharts";

export const RiskTrendsChart = ({ trend }) => (
  <div className="rounded-xl border bg-card p-5" data-testid="dashboard-risk-trends">
    <h3 className="font-display text-base font-semibold">Risk trends</h3>
    <p className="text-xs text-muted-foreground">Assessment volume &amp; high-risk results — last 6 months</p>
    <div className="mt-4 h-56">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={trend || []} margin={{ top: 8, right: 8, left: -20, bottom: 0 }}>
          <defs>
            <linearGradient id="vol2" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="hsl(var(--primary))" stopOpacity={0.25} />
              <stop offset="100%" stopColor="hsl(var(--primary))" stopOpacity={0} />
            </linearGradient>
            <linearGradient id="hi2" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#c93838" stopOpacity={0.22} />
              <stop offset="100%" stopColor="#c93838" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" vertical={false} />
          <XAxis dataKey="month" tickLine={false} axisLine={false} fontSize={12} />
          <YAxis allowDecimals={false} tickLine={false} axisLine={false} fontSize={12} />
          <RTooltip contentStyle={{ borderRadius: 12, border: "1px solid hsl(var(--border))", fontSize: 13 }} />
          <Legend wrapperStyle={{ fontSize: 12 }} />
          <Area type="monotone" name="Total" dataKey="count" stroke="hsl(var(--primary))" strokeWidth={2} fill="url(#vol2)" />
          <Area type="monotone" name="High risk" dataKey="high" stroke="#c93838" strokeWidth={2} fill="url(#hi2)" />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  </div>
);
